export default __webpack_public_path__ + "static/media/README.fdd4f5a9.md";